import { apiClient as api } from "./httpClient";
import { EntityRequest, EntityResponse } from "../types/entity";

export const entityService = {
  getAllEntities: async (): Promise<EntityResponse[]> => {
    const response = await api.get("/Entities");
    // O endpoint devolve um PagedResult ({ items, pageNumber, ... }); o componente espera o array.
    return response.data?.items ?? (Array.isArray(response.data) ? response.data : []);
  },
  createEntity: async (data: EntityRequest): Promise<EntityResponse> => {
    // Backend expoe a criacao em POST /api/entities/register (EntitiesController.Register).
    const response = await api.post("/Entities/register", data);
    return response.data;
  },
  updateEntity: async (id: string, data: EntityRequest): Promise<EntityResponse> => {
    const response = await api.put(`/Entities/${id}`, data);
    return response.data;
  },
  deleteEntity: async (id: string): Promise<void> => {
    await api.delete(`/Entities/${id}`);
  },
  setEntityActive: async (id: string, active: boolean): Promise<void> => {
    await api.patch(`/Entities/${id}/${active ? "activate" : "deactivate"}`);
  },
  // Horários de atendimento por dia da semana (faixas em minutos a partir da meia-noite).
  getBusinessHours: async (entityId: string): Promise<BusinessHour[]> => {
    const response = await api.get(`/Entities/${entityId}/business-hours`);
    return response.data ?? [];
  },
  setBusinessHours: async (entityId: string, hours: BusinessHour[]): Promise<void> => {
    await api.put(`/Entities/${entityId}/business-hours`, { hours });
  },
};

// weekday: 0=domingo … 6=sábado; startMinute/endMinute em minutos a partir da meia-noite.
export interface BusinessHour {
  weekday: number;
  startMinute: number;
  endMinute: number;
}
